module.exports = __webpack_public_path__ + "img/banner_Seasonal_products.ce026d7c.png";